import buildService, { NoParams } from 'common/utils/build-service'
import { GET } from 'common/requests'

export const modulesService = buildService<NoParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'MODULES',
  isArray: true,
  http: {
    createApiUrlSuffix: () => `/modules`,
  },
})
